import "./SetNewPasswordComponent.scss";
import * as Yup from "yup";
import {Field, FieldProps, Form, Formik} from "formik";
import React, {useCallback, useRef, useState} from "react";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import commonService from "../../../shared/services/common.service";
import {IAPIResponseType} from "../../../shared/models/api.model";
import FormikInputComponent from "../../../shared/components/core/formik-input/FormikInputComponent";
import PasswordStrengthCheckerComponent
    from "../../../shared/components/password-strength-checker/PasswordStrengthCheckerComponent";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";

interface SetNewPasswordComponentProps {

}

const validationSchema = Yup.object({
    password: Yup.string()
        .required("Password is required"),
    confirmPassword: Yup.string().when("password", {
        is: (val: string) => (val && val.length > 0 ? true : false),
        then: Yup.string().required("Confirm Password is required").oneOf(
            [Yup.ref("password")],
            "Both password need to be the same"
        )
    })

});

interface updatePasswordFormSchema {
    password: string;
    confirmPassword: string;
}

const initialValues: updatePasswordFormSchema = {
    password: "",
    confirmPassword: "",
}


const SetNewPasswordComponent = (props: SetNewPasswordComponentProps) => {
    const [searchParams] = useSearchParams();
    const [emailId] = useState<string>(searchParams.get("emailId") || "");
    const [validPassword, setValidPassword] = useState<boolean>(false);
    const params = useParams<{otp:string}>();
    const otp = params.otp;
    const navigate = useNavigate();
    const formikRef = useRef<any>(null);

    const onFormSubmit = useCallback((values: updatePasswordFormSchema, {setSubmitting}: any) => {
        const payload = {
            emailId: emailId?.toLowerCase(),
            newPassword: values.password,
            otp: otp
        };
        setSubmitting(true);
        commonService._account.UpdatePassword(payload)
            .then((response:IAPIResponseType<any>) => {
                setSubmitting(false);
                if (response) {
                     navigate(commonService._routeConfig.LoginRoute());
                }
            })
            .catch((error:any) => {
                setSubmitting(false);
                commonService._alert.showToast(error.error, 'error');
            })
    }, [emailId,otp,navigate]);

    return (
        <div className={'set-new-password screen width-100'}>
            <div className="set-new-password-title auth-form-title">
                Set New Password
            </div>
            <div className={'set-new-password-description auth-form-description'}>
                Your new password must be different to previously user passwords.
            </div>
            <Formik
                validationSchema={validationSchema}
                initialValues={initialValues}
                validateOnChange={true}
                validateOnBlur={true}
                innerRef={formikRef}
                onSubmit={onFormSubmit}
            >
                {({values,isSubmitting, validateForm, setFieldError, isValid, setErrors, errors}) => {
                    return (
                        <Form className="t-form" noValidate={true}>
                            <div className="t-form-controls pdd-top-10">
                                <Field name={'password'}>
                                    {
                                        (field: FieldProps) => (
                                            <FormikInputComponent
                                                label={'Password'}
                                                placeholder={'Enter New Password'}
                                                type={'password'}
                                                toggleShowPassword={true}
                                                required={true}
                                                formikField={field}
                                            />
                                        )
                                    }
                                </Field>
                                <PasswordStrengthCheckerComponent password={values.password}
                                                                  isPasswordValid={(isValid: boolean) => {
                                                                      setValidPassword(isValid);
                                                                  }}/>
                                <Field name={'confirmPassword'}>
                                    {
                                        (field: FieldProps) => (
                                            <FormikInputComponent
                                                label={'Password'}
                                                placeholder={'Confirm New Password'}
                                                type={'password'}
                                                required={true}
                                                toggleShowPassword={true}
                                                disabled={!validPassword}
                                                formikField={field}
                                            />
                                        )
                                    }
                                </Field>
                            </div>
                            <div className="t-form-actions">
                                <ButtonComponent
                                    type={"submit"}
                                    size={"large"}
                                    isLoading={isSubmitting}
                                    className={"mrg-top-40"}
                                    disabled={!isValid}
                                    fullWidth={true}
                                >
                                    Reset Password
                                </ButtonComponent>
                            </div>
                        </Form>
                    )
                }}

            </Formik>
        </div>
    );

};

export default SetNewPasswordComponent;
